"use client";

import { AlertTriangle } from "@untitledui/icons";

import { useMaintenanceMode } from "@/hooks/admin/useMaintenanceMode";

export function MaintenanceBanner() {
	const { data: maintenanceData } = useMaintenanceMode();

	// Only show banner if maintenance mode is enabled
	// Non-admin users will get an error, which is fine - they won't see the banner
	const isMaintenanceMode = maintenanceData?.enabled ?? false;

	if (!isMaintenanceMode) {
		return null;
	}

	return (
		<div className="sticky top-0 z-50 w-full border-b border-warning-300 bg-warning-50 px-4 py-3 text-center dark:border-warning-800 dark:bg-warning-950">
			<div className="page-shell flex items-center justify-center gap-2">
				<AlertTriangle className="size-5 text-warning-600 dark:text-warning-400" />
				<p className="text-sm font-medium text-warning-800 dark:text-warning-200">
					<span className="font-semibold">Maintenance Mode Active:</span> The site is currently in
					maintenance mode. Only admins can access the site.
				</p>
			</div>
		</div>
	);
}
